var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"privacy-container"},[_c('h2',[_vm._v("Privacy policy")])])
}]

export { render, staticRenderFns }